import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Box, Divider } from "@mui/material";
import { useParams } from "react-router-dom";
import { LoadingSpinner } from "../../../../components/ui/loadinSpinner";
import {
    useQuery,
} from '@tanstack/react-query'
import { getOccupancyData } from "../../../../services/hospitalDashboardServices";
import MisDoughnutChart from "../../../../components/charts/misDoughnutChart";

const OccpancyCharts = ({
    fromDate,
    toDate,
    country,
    state,
    district,
    taluk,
    hobli,
    serviceType,
    filterApplyToggle,
    title,
    bedType
}: {
    fromDate: any;
    toDate: any;
    country: string;
    state: string;
    district: string;
    taluk: string;
    hobli: string;
    title: string;
    serviceType: number;
    filterApplyToggle: boolean;
    bedType: string
}) => {

    const params = useParams();

    const departmentsData = useSelector(
        (data: any) => data.getPatientDetailsDepartmentsGraphData
    );

    // const [errorMessage, setErrorMessage] = useState<string>("");
    const [departmentsGraphData, setdepartmentsGraphData] = useState<any>([]);

    const { data: occupancyData, isLoading, refetch } = useQuery({
        queryKey: [params?.id, bedType], queryFn: () => getOccupancyData(fromDate,
            toDate,
            country,
            state,
            district,
            taluk,
            hobli,
            serviceType,
            bedType
        )
    })

    useEffect(() => {
        refetch()
    }, [filterApplyToggle])
    console.log(occupancyData);

    interface Hospital {
        name: string;
        patientsCount: number;
        percentage: number;
    }

    let names: string[] = [];
    let totalCount: number[] = [];
    let percentage: number[] = [];

    let name: string[] = [];
    let totalCounts: number[] = [];
    let percentages: number[] = [];

    let othersCount: number[] = [];
    let othersPercentage: number[] = [];

    departmentsGraphData?.patientDetailsSummary?.patientsCountList?.forEach(
        (hospital: Hospital, index: number) => {
            if (index < 5) {
                names.push(hospital.name);
                totalCount.push(hospital.patientsCount);
                percentage.push(hospital.percentage);
            } else {
                othersCount.push(hospital.patientsCount);
                othersPercentage.push(hospital.percentage);
            }
        }
    );

    const otherCount = othersCount?.reduce(
        (acc: number, curr?: number) => acc + (curr ?? 0),
        0
    );
    const otherPercentage = othersPercentage?.reduce(
        (acc: number, curr?: number) => acc + (curr ?? 0),
        0
    );

    const newObjectAtIndex5 = {
        name: "Others",
        patientsCount: otherCount,
        percentage: otherPercentage,
    };

    const index = 4;
    const value = newObjectAtIndex5;
    const newArr = [];
    for (
        let i = 0;
        i < departmentsGraphData?.patientDetailsSummary?.patientsCountList.length;
        i++
    ) {
        if (i === index) {
            newArr.push(value);
        }
        newArr.push(
            departmentsGraphData?.patientDetailsSummary?.patientsCountList[i]
        );
    }

    if (othersCount.length > 0) {
        newArr.forEach((hospital: Hospital, index: number) => {
            if (index < 5) {
                name.push(hospital.name);
                totalCounts.push(hospital.patientsCount);
                percentages.push(hospital.percentage);
            }
        });
    }

    const ctx = document.createElement("canvas").getContext("2d");
    const gradient = ctx?.createLinearGradient(0, 0, 200, 0);
    if (gradient) {
        gradient.addColorStop(0, "#FADEB0");
        gradient.addColorStop(1, "#F5B44B");
    }

    // const data = {
    //     labels: othersCount.length > 0 ? name : names,
    //     datasets: [
    //         {
    //             label: "value",
    //             backgroundColor: gradient,
    //             barPercentage: 0.6,
    //             borderColor: "#F7C068",
    //             borderWidth: 1,
    //             hoverBackgroundColor: gradient,
    //             hoverBorderColor: "#F7C068",
    //             data: othersCount.length > 0 ? totalCounts : totalCount,
    //         },
    //     ],
    // };

    // useEffect(() => {
    //     if (departmentsData?.status === "success") {
    //         setErrorMessage("");
    //         setdepartmentsGraphData(departmentsData?.data?.data ?? []);
    //     } else if (departmentsData?.status === "failed") {
    //         setErrorMessage("Something went Wrong");
    //     }
    // }, [departmentsData]);

    // useEffect(() => {
    //     dispatch(
    //         getPatientDetailsDepartmentsGraphData({
    //             country: country,
    //             state: state,
    //             district: district,
    //             taluk: taluk,
    //             hobli: hobli,
    //             serviceType: serviceType,
    //             fromDate: moment(fromDate).format("YYYY-MM-DD"),
    //             toDate: moment(toDate).format("YYYY-MM-DD"),
    //             hospitals: [],
    //         })
    //     );
    // }, [filterApplyToggle, fromDate, toDate]);

    return (
        <>

            <div className="p-4 bg-white border border-gray-250  shadow-sm1 rounded-lg w-full">

                {isLoading ? (
                    <div className="flex justify-center items-center h-full">
                        <LoadingSpinner />
                    </div>
                ) : (
                    <>
                        {(occupancyData?.counts || [])?.length > 0 ? (
                            <Box sx={{ height: "100%", display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
                                <div>
                                    <div style={{}}>
                                        <span className="text-18 font-medium text-primary mx-2">
                                            {title}
                                        </span>
                                    </div>
                                    <div className="pt-2 flex items-center">
                                        {(occupancyData?.subTitles || [])?.length > 0 && occupancyData?.subTitles?.map((v, i) => <div className={i !== occupancyData?.subTitles?.length - 1 ? "border-r-2 border-gray-250 mx-2" : "mx-2"}>
                                            <span className="text-14 font-[400] text-secondary">
                                                {v?.title} :
                                            </span>
                                            <span className="text-14 font-[700] text-primary mx-1 pe-2">
                                                {v?.count?.toLocaleString(
                                                    "en-IN"
                                                )} {v?.percentage && `(${v?.percentage}%)`}
                                            </span>
                                        </div>)}


                                    </div></div>
                                {/* <Box sx={{ marginTop: "6px" }}> */}
                                {bedType === "OT" && (
                                    <Box display="flex" gap="16px" className="h-[100%] min-w-full justify-between mt-10">
                                        {[<Box display="flex" flexDirection="column" minWidth="110px" className='mt-10'>
                                            <span className="text-14 font-[400] text-secondary">No. of Tables </span>
                                            <span className="text-14 font-[700] text-primary mx-1 pe-2">{1200?.toLocaleString("en-IN")}</span>
                                            <span className="text-14 font-[400] text-secondary mt-10">No. of Surgeries </span>
                                            <span className="text-14 font-[700] text-primary mx-1 pe-2">{1200?.toLocaleString("en-IN")}</span>
                                        </Box>,
                                        <Divider flexItem orientation="vertical" sx={{ borderStyle: "dashed" }} />,
                                        <div className="h-[100%] w-[100%]">
                                            <MisDoughnutChart
                                                totalValue={occupancyData?.total}
                                                name={occupancyData?.names as string[]}
                                                counts={occupancyData?.counts as number[]}
                                                percentage={occupancyData?.percentages as number[]}
                                                colors={occupancyData?.colors as string[]}
                                                title={title}
                                            />
                                        </div>
                                        ]}</Box>
                                )}
                                {bedType !== "OT" && <div className="pb-15">
                                    <MisDoughnutChart
                                        totalValue={occupancyData?.total}
                                        name={occupancyData?.names as string[]}
                                        counts={occupancyData?.counts as number[]}
                                        percentage={occupancyData?.percentages as number[]}
                                        colors={occupancyData?.colors as string[]}
                                        title={title}
                                    />
                                </div>}
                                {/* </Box> */}
                            </Box>
                        ) : (
                            <>
                                <div className="flex justify-center items-center h-full">
                                    <span className="text-18 font-medium text-primary">
                                        No Data Found
                                    </span>
                                </div>
                            </>
                        )}
                    </>
                )}
            </div >
        </>
    );
};
export default OccpancyCharts